import { fadyPhoto } from "./FadyPhotoBase64";
import { joePhoto } from "./JoePhotoBase64";
import { emilioPhoto } from "./EmilioPhotoBase64";
import { doryPhoto } from "./DoryPhotoBase64";
import { georgePhoto } from "./GeorgePhotoBase64";
export const coaches = {
  fady: {
    FirstName:"Fady",
    LastName:"Atallah",
    CertificationSource:"CIS College",
    YearsOfExperience:"2014",
    HowDoIStartWorkout:"By Taking decision and making the first step",
    WhyDoILikeToTrain:"This is my passion",
    WhatIsMyGoal:"Sharing my experience with every one",
    MainReasonToJoinTheFamily:"I joined to help you",
    PhoneNumber:"+96170552291",
    Instagram:"https://www.instagram.com/coach_fady.a?igsh=MWE2aXMxbzMwbzc1eA==",
    Tiktok:"",
    photo : fadyPhoto.base64
  },
  dory: {
    FirstName:"Dory",
    LastName:"Jabbour",
    CertificationSource:"The national academy of physical culture",
    YearsOfExperience:"2017",
    HowDoIStartWorkout:"By setting clear goals and choosing the right workout",
    WhyDoILikeToTrain:"To improve my health, fitness and well-being",
    WhatIsMyGoal:"Help people acheive their fitness objectives",
    MainReasonToJoinTheFamily:"Show people positive results over time",
    PhoneNumber:"+96170414629",
    Instagram:"https://www.instagram.com/dory.jabbour?igsh=bHdwbWxwaXhoY2x4",
    Tiktok:"",
    photo : doryPhoto.base64
  },
  joe: {
    FirstName:"Joe",
    LastName:"Kassab",
    CertificationSource:"Inspire fitness academy",
    YearsOfExperience:"2019",
    HowDoIStartWorkout:"By taking decision to start a healthy life style",
    WhyDoILikeToTrain:"Keep a healthy and strong body",
    WhatIsMyGoal:"Help you achieve what you desire",
    MainReasonToJoinTheFamily:"Educate society about the fitness industry",
    PhoneNumber:"+96170986427",
    Instagram:"https://www.instagram.com/joekassab_?igsh=dDB2czFiaTUycjhh",
    Tiktok:"",
    photo : joePhoto.base64
  },
  emilio: {
    FirstName:"Emilio",
    LastName:"Kassab",
    CertificationSource:"No Certification",
    YearsOfExperience:"2020",
    HowDoIStartWorkout:"Motivated by success stories",
    WhyDoILikeToTrain:"To keep myself fit and be able to do whatever i want",
    WhatIsMyGoal:"Showing the people the beauty of working out",
    MainReasonToJoinTheFamily:"Keeping people healthy",
    PhoneNumber:"+96170096448",
    Instagram:"https://www.instagram.com/kassabemilio?igsh=MWZqYWloenpkamRnMQ==",
    Tiktok:"",
    photo : emilioPhoto.base64
  },
  ranime: {
    FirstName:"ranime",
    LastName:"najem",
    CertificationSource:"",
    YearsOfExperience:"",
    HowDoIStartWorkout:"",
    WhyDoILikeToTrain:"",
    WhatIsMyGoal:"",
    MainReasonToJoinTheFamily:"",
    PhoneNumber:"+9613643916",
    Instagram:"https://www.instagram.com/ranimnajem?igsh=MTdxeXh1NDRsc2pobg==",
    Tiktok:"",
  },
  
};
export const physio = {
  george: {
    FirstName:"George",
    LastName:"Khoury",
    CertificationSource:"Sagesse University",
    YearsOfExperience:"2018",
    HowDoIStartWorkout:"HowDoIStartWorkout",
    WhyDoILikeToTrain:"WhyDoILikeToTrain",
    WhatIsMyGoal:"Helping people regain their activities and life normally",
    MainReasonToJoinTheFamily:"For the love of help",
    PhoneNumber:"+96171170217",
    Instagram:"https://www.instagram.com/georgekhouryy_1?igsh=NWVka3hhaHJycnA4",
    Tiktok:"",
    photo : georgePhoto.base64
  },
  dory: {
    FirstName:"Dory",
    LastName:"Jabbour",
    CertificationSource:"Saida",
    YearsOfExperience:"9",
    HowDoIStartWorkout:"",
    WhyDoILikeToTrain:"",
    WhatIsMyGoal:"",
    MainReasonToJoinTheFamily:""
  },
  joe: {
    FirstName:"Joe",
    LastName:"Kassab",
    CertificationSource:"Inspire",
    YearsOfExperience:"9",
    HowDoIStartWorkout:"",
    WhyDoILikeToTrain:"",
    WhatIsMyGoal:"",
    MainReasonToJoinTheFamily:""
  },
  emilio: {
    FirstName:"Emilio",
    LastName:"Kassab",
    CertificationSource:"No Certification",
    YearsOfExperience:"9",
    HowDoIStartWorkout:"",
    WhyDoILikeToTrain:"",
    WhatIsMyGoal:"",
    MainReasonToJoinTheFamily:""
  },
  ranime: {
    FirstName:"ranime",
    LastName:"najem",
    CertificationSource:"Certification",
    YearsOfExperience:"9",
    HowDoIStartWorkout:"",
    WhyDoILikeToTrain:"",
    WhatIsMyGoal:"",
    MainReasonToJoinTheFamily:""
  },
  
};
export const nutritionist = {
  dayane: {
    FirstName:"Dayane",
    LastName:"Saikaly",
    CertificationSource:"Saida",
    YearsOfExperience:"9",
    HowDoIStartWorkout:"HowDoIStartWorkout",
    WhyDoILikeToTrain:"WhyDoILikeToTrain",
    WhatIsMyGoal:"WhatIsMyGoal",
    MainReasonToJoinTheFamily:"MainReasonToJoinTheFamily",
    PhoneNumber:"",
    Instagram:"",
    Tiktok:"",
  },
  dory: {
    FirstName:"Dory",
    LastName:"Jabbour",
    CertificationSource:"Saida",
    YearsOfExperience:"9",
    HowDoIStartWorkout:"",
    WhyDoILikeToTrain:"",
    WhatIsMyGoal:"",
    MainReasonToJoinTheFamily:""
  },
  joe: {
    FirstName:"Joe",
    LastName:"Kassab",
    CertificationSource:"Inspire",
    YearsOfExperience:"9",
    HowDoIStartWorkout:"",
    WhyDoILikeToTrain:"",
    WhatIsMyGoal:"",
    MainReasonToJoinTheFamily:""
  },
  emilio: {
    FirstName:"Emilio",
    LastName:"Kassab",
    CertificationSource:"No Certification",
    YearsOfExperience:"9",
    HowDoIStartWorkout:"",
    WhyDoILikeToTrain:"",
    WhatIsMyGoal:"",
    MainReasonToJoinTheFamily:""
  },
  ranime: {
    FirstName:"ranime",
    LastName:"najem",
    CertificationSource:"Certification",
    YearsOfExperience:"9",
    HowDoIStartWorkout:"",
    WhyDoILikeToTrain:"",
    WhatIsMyGoal:"",
    MainReasonToJoinTheFamily:""
  },
  
};
